import { faGlobe, faLockKeyhole } from '@fortawesome/pro-regular-svg-icons';
import Button from '@sharedComponents/Button';
import ChoiceCard from '@sharedComponents/ChoiceCard';
import FlexBox from '@sharedComponents/FlexBox';
import FormGroup from '@sharedComponents/FormGroup';
import InputText from '@sharedComponents/InputText';
import { useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

/**
 * Side panel creating a collection from its French name and scope; the rest is filled in on the
 * collection page, opened by the caller once `onCreate(payload)` succeeds.
 */
const CollectionCreatePanel = ({ onCreate = async () => {} } = {}) => {
    const { t } = useTranslation('bo');
    const {
        register,
        handleSubmit,
        control,
        setValue,
        formState: { errors, isSubmitting },
    } = useForm({ defaultValues: { name: '', visibility: 'PUBLIC' } });
    const visibility = useWatch({ control, name: 'visibility' });

    const submit = (data) =>
        onCreate({
            name: JSON.stringify({ fr: data.name.trim() }),
            description: '{}',
            testReferences: [],
            tagsIds: [],
            visibility: data.visibility,
        });

    return (
        <FlexBox flexDirection="column" gap="m">
            <FormGroup label={t('Name (French)')} errorMsg={errors.name?.message}>
                <InputText
                    aria-label={t('Name (French)')}
                    isError={Boolean(errors.name)}
                    {...register('name', { validate: (value) => value.trim() !== '' || t('The French name is required') })}
                />
            </FormGroup>
            <FormGroup label={t('Access')}>
                <FlexBox role="radiogroup" aria-label={t('Access')} gap="s" flexWrap="wrap">
                    <ChoiceCard
                        icon={faGlobe}
                        title={t('Public')}
                        description={t('Available to all clients, according to their activated packs.')}
                        selected={visibility === 'PUBLIC'}
                        onSelect={() => setValue('visibility', 'PUBLIC')}
                    />
                    <ChoiceCard
                        icon={faLockKeyhole}
                        title={t('Restricted')}
                        description={t('Visible only to the clients authorized on the collection page.')}
                        selected={visibility === 'RESTRICTED'}
                        onSelect={() => setValue('visibility', 'RESTRICTED')}
                    />
                </FlexBox>
            </FormGroup>
            <FlexBox justifyContent="flex-end">
                <Button label={t('Create the collection')} action={handleSubmit(submit)} disabled={isSubmitting} isLoading={isSubmitting} />
            </FlexBox>
        </FlexBox>
    );
};

export default CollectionCreatePanel;
